import { Trans } from '@lingui/react/macro';
import React from 'react';

interface UserNameProps {
  displayName: string;
  role?: string;
}

export function UserName({ displayName, role }: UserNameProps) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {displayName}
      {role === 'agent' && (
        <span
          style={{
            fontSize: 10,
            fontWeight: 600,
            background: 'var(--accent-primary, #5865f2)',
            color: '#fff',
            borderRadius: 3,
            padding: '1px 4px',
            lineHeight: 1.2,
          }}
        >
          <Trans>APP</Trans>
        </span>
      )}
    </span>
  );
}
